/* eslint-disable max-len */
import { NavLink } from 'react-router-dom';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';

const BASE_URL = `/${routes.UTILITIES}`;
const title = 'Utils';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getUtilitiesMenuItems = () => {
    const menu = [
        {
            group: 'Helper',
            navItems: [
                {
                    key: 'classNames',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/classNames`}>
                            classNames
                        </NavLink>
                    ),
                    meta: 'classNames className classes helper util',
                },
                {
                    key: 'deviceUtils',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/deviceUtils`}>
                            Device utils
                        </NavLink>
                    ),
                    meta: 'deviceUtils',
                },
                {
                    key: 'fuelTypeUtils',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/fuelTypeUtils`}>
                            Fuel type utils
                        </NavLink>
                    ),
                    meta: 'fuelTypeUtils fuelIcon fuelTypeIcon',
                },
                {
                    key: 'routeUtils',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/routeUtils`}>
                            Route utils
                        </NavLink>
                    ),
                    meta: 'routeUtils',
                },
                {
                    key: 'googleAnalyticsUtils',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/getTrackingAttributes`}>
                            Google Analytics Utils
                        </NavLink>
                    ),
                    meta: 'googleAnalyticsUtils getTrackingAttributes googleAnalytics analytics helper util tracking',
                },
                {
                    key: 'URLFeatureToggles',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/featureToggles`}>
                            URL feature toggles
                        </NavLink>
                    ),
                    meta: 'URLFeatureToggles URL feature toggles',
                },
            ],
        },
        {
            group: 'Lifecycle & execution hooks',
            navItems: [
                {
                    key: 'useAfterMount',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useAfterMount`}>
                            useAfterMount
                        </NavLink>
                    ),
                    meta: 'useAfterMount hook',
                },
                {
                    key: 'useEffectOnce',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useEffectOnce`}>
                            useEffectOnce
                        </NavLink>
                    ),
                    meta: 'useEffectOnce hook',
                },
                {
                    key: 'useElapsedTime',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useElapsedTime`}>
                            useElapsedTime
                        </NavLink>
                    ),
                    meta: 'useElapsedTime timeout hook',
                },
                {
                    key: 'useInterval',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useInterval`}>
                            useInterval
                        </NavLink>
                    ),
                    meta: 'useInterval hook',
                },
                {
                    key: 'usePrevious',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/usePrevious`}>
                            usePrevious
                        </NavLink>
                    ),
                    meta: 'usePrevious hook',
                },
                {
                    key: 'useTimeout',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useTimeout`}>
                            useTimeout
                        </NavLink>
                    ),
                    meta: 'useTimeout hook',
                },
                {
                    key: 'useToggle',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useToggle`}>
                            useToggle
                        </NavLink>
                    ),
                    meta: 'useToggle hook state boolean',
                },
            ],
        },
        {
            group: 'DOM behavior hooks',
            navItems: [
                {
                    key: 'useAutoAnimate',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useAutoAnimate`}>
                            useAutoAnimate
                        </NavLink>
                    ),
                    meta: 'useAutoAnimate hook animation',
                },
                {
                    key: 'useClickOutside',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useClickOutside`}>
                            useClickOutside
                        </NavLink>
                    ),
                    meta: 'useClickOutside hook',
                },
                {
                    key: 'useDraggableElement',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useDraggableElement`}>
                            useDraggableElement
                        </NavLink>
                    ),
                    meta: 'useDraggableElement hook drag pointer',
                },
                {
                    key: 'useElementSize',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useElementSize`}>
                            useElementSize
                        </NavLink>
                    ),
                    meta: 'useElementSize hook',
                },
                {
                    key: 'useEsc',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useEsc`}>
                            useEsc
                        </NavLink>
                    ),
                    meta: 'useEsc hook',
                },
                {
                    key: 'useFocusTrap',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useFocusTrap`}>
                            useFocusTrap
                        </NavLink>
                    ),
                    meta: 'useFocusTrap hook',
                },
                {
                    key: 'useFullscreen',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useFullscreen`}>
                            useFullscreen
                        </NavLink>
                    ),
                    meta: 'useFullscreen hook',
                },
                {
                    key: 'useHover',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useHover`}>
                            useHover
                        </NavLink>
                    ),
                    meta: 'useHover hook',
                },
                {
                    key: 'useIsFocusWithin',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useIsFocusWithin`}>
                            useIsFocusWithin
                        </NavLink>
                    ),
                    meta: 'useIsFocusWithin hook',
                },
                {
                    key: 'useKey',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useKey`}>
                            useKey
                        </NavLink>
                    ),
                    meta: 'useKey hook',
                },
                {
                    key: 'useMutationObserver',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useMutationObserver`}>
                            useMutationObserver
                        </NavLink>
                    ),
                    meta: 'useMutationObserver hook',
                },
                {
                    key: 'useOnScreen',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useOnScreen`}>
                            useOnScreen
                        </NavLink>
                    ),
                    meta: 'useOnScreen hook',
                },
                {
                    key: 'useResizeObserver',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useResizeObserver`}>
                            useResizeObserver
                        </NavLink>
                    ),
                    meta: 'useResizeObserver resize observer hook',
                },
                {
                    key: 'useScrollPosition',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useScrollPosition`}>
                            useScrollPosition
                        </NavLink>
                    ),
                    meta: 'useScrollPosition hook scroll position offset',
                },
                {
                    key: 'useWindowResize',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useWindowResize`}>
                            useWindowResize
                        </NavLink>
                    ),
                    meta: 'useWindowResize hook',
                },
            ],
        },
        {
            group: 'Browser & device hooks',
            navItems: [
                {
                    key: 'useClipboard',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useClipboard`}>
                            useClipboard
                        </NavLink>
                    ),
                    meta: 'useClipboard hook',
                },
                {
                    key: 'useCookies',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useCookies`}>
                            useCookies
                        </NavLink>
                    ),
                    meta: 'useCookies hook browser cookie',
                },
                {
                    key: 'useRioCookieConsent',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useRioCookieConsent`}>
                            useRioCookieConsent
                        </NavLink>
                    ),
                    meta: 'useRioCookieConsent hook cookie consent',
                },
                {
                    key: 'useDarkMode',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useDarkMode`}>
                            useDarkMode
                        </NavLink>
                    ),
                    meta: 'useDarkMode hook',
                },
                {
                    key: 'useIncomingPostMessages',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useIncomingPostMessages`}>
                            useIncomingPostMessages
                        </NavLink>
                    ),
                    meta: 'useIncomingPostMessages hook',
                },
                {
                    key: 'useLocalStorage',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useLocalStorage`}>
                            useLocalStorage / useSessionStorage
                        </NavLink>
                    ),
                    meta: 'useLocalStorage hook',
                },
                {
                    key: 'useOnlineStatus',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useOnlineStatus`}>
                            useOnlineStatus
                        </NavLink>
                    ),
                    meta: 'useOnlineStatus hook',
                },
                {
                    key: 'usePostMessage',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/usePostMessage`}>
                            usePostMessage
                        </NavLink>
                    ),
                    meta: 'usePostMessage hook iframe event widget',
                },
                {
                    key: 'usePostMessageSender',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/usePostMessageSender`}>
                            usePostMessageSender
                        </NavLink>
                    ),
                    meta: 'usePostMessageSender hook iframe event widget',
                },
            ],
        },
        {
            group: 'UI state & input hooks',
            navItems: [
                {
                    key: 'useDebugInfo',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useDebugInfo`}>
                            useDebugInfo
                        </NavLink>
                    ),
                    meta: 'useDebugInfo hook',
                },
                {
                    key: 'useEvent',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useEvent`}>
                            useEvent
                        </NavLink>
                    ),
                    meta: 'useEvent hook',
                },
                {
                    key: 'useLocationSuggestions',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useLocationSuggestions`}>
                            useLocationSuggestions
                        </NavLink>
                    ),
                    meta: 'useLocationSuggestions here map places hook',
                },
                {
                    key: 'useSearch',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useSearch`}>
                            useSearch
                        </NavLink>
                    ),
                    meta: 'useSearch hook filter',
                },
                {
                    key: 'useUrlState',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useUrlState`}>
                            useUrlState
                        </NavLink>
                    ),
                    meta: 'useUrlState hook url state',
                },
                {
                    key: 'useSearchHighlight',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useSearchHighlight`}>
                            useSearchHighlight
                        </NavLink>
                    ),
                    meta: 'useSearchHighlight hook filter result highlighting',
                },
                {
                    key: 'useStateWithValidation',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useStateWithValidation`}>
                            useStateWithValidation
                        </NavLink>
                    ),
                    meta: 'useStateWithValidation hook',
                },
            ],
        },
        {
            group: 'Data aggregation hooks',
            navItems: [
                {
                    key: 'useAverage',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useAverage`}>
                            useAverage
                        </NavLink>
                    ),
                    meta: 'useAverage hook calculate',
                },
                {
                    key: 'useCount',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useCount`}>
                            useCount
                        </NavLink>
                    ),
                    meta: 'useCount hook calculate',
                },
                {
                    key: 'useMax',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useMax`}>
                            useMax
                        </NavLink>
                    ),
                    meta: 'useMax hook maximum highest calculate',
                },
                {
                    key: 'useMin',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useMin`}>
                            useMin
                        </NavLink>
                    ),
                    meta: 'useMin hook minimum lowest calculate',
                },
                {
                    key: 'useSum',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useSum`}>
                            useSum
                        </NavLink>
                    ),
                    meta: 'useSum hook summarize calculate',
                },
            ],
        },
        {
            group: 'Table & data hooks',
            navItems: [
                {
                    key: 'useSorting',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useSorting`}>
                            useSorting
                        </NavLink>
                    ),
                    meta: 'useSorting hook order sort ascending descending',
                },
                {
                    key: 'useTableExport',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useTableExport`}>
                            useTableExport
                        </NavLink>
                    ),
                    meta: 'useTableExport table data download hook csv excel',
                },
                {
                    key: 'useTableSelection',
                    item: (
                        <NavLink className={navLinkClass} to={`${BASE_URL}/useTableSelection`}>
                            useTableSelection
                        </NavLink>
                    ),
                    meta: 'useTableSelection table selection hook bulk',
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const UtilitiesMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
